import api from './http';

const BACKFILL_PHASES = ['customers', 'links', 'masters'];

function createBackfillSummary() {
  return {
    customersScanned: 0,
    customersUpdated: 0,
    linksScanned: 0,
    linksUpdated: 0,
    masterClientsScanned: 0,
    masterClientsUpdated: 0,
    batches: 0
  };
}

function addBackfillBatch(summary, batch) {
  summary.customersScanned += batch.customersScanned || 0;
  summary.customersUpdated += batch.customersUpdated || 0;
  summary.linksScanned += batch.linksScanned || 0;
  summary.linksUpdated += batch.linksUpdated || 0;
  summary.masterClientsScanned += batch.masterClientsScanned || 0;
  summary.masterClientsUpdated += batch.masterClientsUpdated || 0;
  summary.batches += 1;
}

export const ClientConsolidationAPI = {
  suggestions: () => api.get('/client-consolidation/suggestions').then((response) => response.data),
  search: (q) => api.get('/client-consolidation/search', { params: { q } }).then((response) => response.data),
  masters: (params = {}) => api.get('/client-consolidation/masters', { params }).then((response) => response.data),
  links: (params = {}) => api.get('/client-consolidation/links', { params }).then((response) => response.data),
  documentMismatches: () => api.get('/client-consolidation/reports/document-mismatches').then((response) => response.data),
  masterDetail: (masterClientId) => api.get(`/client-consolidation/masters/${masterClientId}`).then((response) => response.data),
  auditCandidates: (masterClientId) => api.get(`/client-consolidation/master/${masterClientId}/audit-candidates`).then((response) => response.data),
  dataComparison: (masterClientId) => api.get(`/client-consolidation/master/${masterClientId}/data-comparison`).then((response) => response.data),
  applyDataCompletion: (masterClientId, updates) => api.post(`/client-consolidation/master/${masterClientId}/apply-data-completion`, { updates }).then((response) => response.data),
  linkCandidates: (masterClientId, selectedCandidates) => api.post(`/client-consolidation/master/${masterClientId}/link-candidates`, { selectedCandidates }).then((response) => response.data),
  masterQuality: () => api.get('/client-consolidation/reports/master-quality').then((response) => response.data),
  updateMaster: (masterClientId, payload) => api.patch(`/client-consolidation/masters/${masterClientId}`, payload).then((response) => response.data),
  deleteMaster: (masterClientId) => api.delete(`/client-consolidation/masters/${masterClientId}`).then((response) => response.data),
  manualLink: (masterClientId, payload) => api.post(`/client-consolidation/masters/${masterClientId}/manual-link`, payload).then((response) => response.data),
  unlink: (linkId) => api.delete(`/client-consolidation/links/${linkId}`).then((response) => response.data),
  mergeMasters: (payload) => api.post('/client-consolidation/merge-masters', payload).then((response) => response.data),
  linkSelected: (payload) => api.post('/client-consolidation/link-selected', payload).then((response) => response.data),
  createMasterWithSelected: (payload) => api.post('/client-consolidation/create-master-with-selected', payload).then((response) => response.data),
  completeMasterData: (masterClientId, fields) => api.post(`/client-consolidation/masters/${masterClientId}/complete-data`, { fields }).then((response) => response.data),
  approve: (suggestionId) => api.post('/client-consolidation/approve', { suggestionId }).then((response) => response.data),
  ignore: (suggestionId) => api.post('/client-consolidation/ignore', { suggestionId }).then((response) => response.data),
  createMaster: (externalCustomerId) => api.post('/client-consolidation/create-master', { externalCustomerId }).then((response) => response.data),
  reprocess: () => api.post('/client-consolidation/reprocess').then((response) => response.data),
  backfillNormalizedData: (params = {}) => api.post('/client-consolidation/backfill-normalized-data', null, { params }).then((response) => response.data),
  backfillAllNormalizedData: async ({ limit = 200 } = {}) => {
    const summary = createBackfillSummary();
    for (const phase of BACKFILL_PHASES) {
      let cursor = '';
      let hasMore = true;
      while (hasMore) {
        const batch = await api.post('/client-consolidation/backfill-normalized-data', null, {
          params: { phase, cursor, limit }
        }).then((response) => response.data);
        addBackfillBatch(summary, batch);
        cursor = batch.nextCursor || '';
        hasMore = Boolean(batch.hasMore && cursor);
      }
    }
    return { ok: true, ...summary };
  },
};
